export const getReportsLoading = (state) => state.reports.loading;
export const getReportFilters = (state) => state.reports.filters;
export const getReportFilterByName = (name) => (state) => state.reports.filters[name];
export const getReportFiltersAdded = (state) => state.reports.filtersAdded;
export const getReports = (state) => state.reports.data;
export const getReportsState = (state) => state.reports;
